import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../shared/services/api/api.service';
import { ICalculateWatchHour, ICreateWatch, IGetWatchFilters,IGetWatchEmailFilters, ISendEmailToWatchUsers, IWatch, WatchFilters } from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class WatchService {


constructor(private readonly apiService: ApiService) {}

  getData(filter:IGetWatchFilters): Observable<any[]> {
    return this.apiService.post<IWatch[]>('watch/get-all', filter);
  }

  addData(newItem: ICreateWatch): Observable<any> {
    return this.apiService.post<IWatch>('watch/create', newItem);
   }

  updateData(id:number,item:any): Observable<any> {
   return this.apiService.patch<IWatch>('watch/update', {...item,id});
  }

  deleteRow(id: any): Observable<any> {
    return this.apiService.delete<IWatch>(`watch/delete/${id}`);
  }

  calculateWatchHours(data: ICalculateWatchHour): Observable<{yearHour:string,monthHour:string}> {
    return this.apiService.post<{yearHour:string,monthHour:string}>('watch/calculateWatchHours-watch', data);
   }

  getWatchListForEmail(filter:IGetWatchEmailFilters): Observable<any[]> {
    return this.apiService.post<IWatch[]>('watch/get-all-watch-for-email-list', filter);
  }

  sendEmailToWatchUsers(data:ISendEmailToWatchUsers){
    return this.apiService.post<IWatch>('watch/send-email-to-watch-users', data);
  }
  getVehiclesDropdownByDate(filter:{date:Date}): Observable<any[]> {
    return this.apiService.post<IWatch[]>('watch/get-vehicles-dropdown-by-date', filter);
  }

  getWatchStaff(filter:{vehicleId?:number,dotId?:number,startDate?:Date,endDate?:Date}){
    return this.apiService.post<{success:boolean,staffs:any[]}>('watch/get-staff-by-watch', filter);
  }

  getFilterData(filter:WatchFilters): Observable<any[]>{
    return this.apiService.post<any>('watch/get-filter', filter);
  }

  getById(id: number): Observable<any>  {
    return this.apiService.post<any>(`watch/get-id/`, {id});
  }


  updateIsCome(id: string, isCome: boolean): Observable<any> {
    return this.apiService.patch(`watch/update-isCome/${id}`, { isCome });
  }

  getLogs(watchId: string){
    return this.apiService.get<any>(`watch/${watchId}/logs`, );
  }
}
